import React from 'react';
import './card-list.styles.css';
import {Card} from "../card/card.component";

export const CardList = ({posts,onHandleDelete,onHandleLike}) => {
    return (
        <div className="card-list row">

            {posts.map(post =>
                <Card
                    key={post.id} post={post}
                    onDelete={onHandleDelete}
                    onLike={onHandleLike}
                />
            )}

        </div>
    )
};